<template>
  <div>
    <div class="home-container">
      <list v-model="isLoading"
            loading-text=" "
            :finished="dataLoadingFinished"
            @load="InitItemFeed"
      >
        <MomentList :data="dataList"></MomentList>
      </list>
    </div>
  </div>
</template>

<script>
  import {Toast, List} from "vant"
  import MomentList from "./MomentList";

  export default {
    name: "MomentItemFeed",
    components: {
      MomentList, Toast, List
    },
    props: {
      listType: {},
    },
    data() {
      return {
        currentPage: 1,
        maxCursor: 0,
        totalCount: 0,
        countPerPage: 0,
        offset: 0,

        isLoading: false,
        dataLoadingFinished: false,
        needShowDataList: true,

        dataList: [],
      };
    },
    mounted() {
      this.initParams()
    },
    methods: {
      initParams() {
        let curPage = this.$route.query.page
        if (curPage) {
          this.currentPage = parseInt(curPage)
        } else {
          this.currentPage = 1
        }
        this.offset = 0
        this.dataList = []
        this.dataLoadingFinished = false
      },

      async InitItemFeed() {
        this.isLoading = true
        let params = {
          page: this.currentPage,
          offset: this.offset,
          list_type: this.listType,
        }
        await this.$store.dispatch("GetFeedItemList", params).then((result) => {
          if (result.code === 0) {
            this.dataList.push(...result.data);
            let extra = result.extra
            this.totalCount = extra.total_count
            this.countPerPage = extra.count_per_page
            this.offset = extra.max_cursor  // 下一次请求的 offset
            this.dataLoadingFinished = !extra.has_more
          } else if (result.code === 20010) {
            this.dataList = []
            this.totalCount = 0
            this.dataLoadingFinished = true
          } else {
            Toast("请求错误")
            this.dataLoadingFinished = true
          }
        }, () => {
          Toast("网络异常")
          this.dataLoadingFinished = true
        });
        this.isLoading = false
      },

      onChange() {
        let params = {
          page: this.currentPage,
          list_type: this.listType,
        }
        this.$router.push({query: params})
        this.initParams()
        this.InitItemFeed()
      },

      onLoginSuccess() {
        window.location.reload()
      }
    },
    computed: {},
    watch: {
      listType() {
        this.currentPage = 0
        this.onChange()
      },
    }
  };
</script>

<style scoped>
  .home-container {
    position: relative;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
</style>
